// OddsMonkeyComponents.jsx
import React, { useState, useEffect } from "react";

// Outer wrapper: adds 30px margin on top and bottom.
const outerWrapperStyle = {
  margin: "30px 0",
  width: "fit-content"
};

// Inner wrapper: centers the content.
const innerWrapperStyle = {
  display: "inline-block",
};

// OddsMonkeyMobMB Component
export const OddsMonkeyMobMB = () => (
  <div style={outerWrapperStyle}>
    <div style={innerWrapperStyle}>
      <a
        href="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317_0_1_36"
        target="_blank"
        rel="noreferrer"
      >
        <img
          style={{ border: "0px" }}
          src="https://www.oddsmonkey.com/affiliates/media/banners/affiliate-banner_2b_360.jpg"
          width="336"
          height="280"
          alt=""
        />
      </a>
    </div>
  </div>
);

// OddsMonkeyMobFT Component
export const OddsMonkeyMobFT = () => (
  <div style={outerWrapperStyle}>
    <div style={innerWrapperStyle}>
      <a
        href="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317_0_1_37"
        target="_blank"
        rel="noreferrer"
      >
        <img
          style={{ border: "0px" }}
          src="https://www.oddsmonkey.com/affiliates/media/banners/affiliate-banner_3.jpg"
          width="300"
          height="250"
          alt=""
        />
      </a>
    </div>
  </div>
);

// OddsMonkeyDesktopFT Component
export const OddsMonkeyDesktopFT = () => (
  <div style={outerWrapperStyle}>
    <div style={innerWrapperStyle}>
      <a
        href="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317_0_1_35"
        target="_blank"
        rel="noreferrer"
      >
        <img
          style={{ border: "0px" }}
          src="https://www.oddsmonkey.com/affiliates/media/banners/affiliate-banner_1.jpg"
          width="728"
          height="90"
          alt=""
        />
      </a>
    </div>
  </div>
);

// OddsMonkeyFT Component (Responsive):
// - Renders OddsMonkeyDesktopFT for screens wider than 800px
// - Renders OddsMonkeyMobFT for screens 800px wide or less.
export const OddsMonkeyFT = () => {
  // Determine the initial width (ensuring it works with server-side rendering).
  const initialWidth =
    typeof window !== "undefined" && window.innerWidth
      ? window.innerWidth
      : 1024;
  const [width, setWidth] = useState(initialWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    // Listen for window resize events.
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={outerWrapperStyle}>
      <div style={innerWrapperStyle}>
        {width > 800 ? (
          <a
            href="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317_0_1_35"
            target="_blank"
            rel="noreferrer"
          >
            <img
              style={{ border: "0px" }}
              src="https://www.oddsmonkey.com/affiliates/media/banners/affiliate-banner_1.jpg"
              width="728"
              height="90"
              alt=""
            />
          </a>
        ) : (
          <a
            href="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317_0_1_37"
            target="_blank"
            rel="noreferrer"
          >
            <img
              style={{ border: "0px" }}
              src="https://www.oddsmonkey.com/affiliates/media/banners/affiliate-banner_3.jpg"
              width="300"
              height="250"
              alt=""
            />
          </a>
        )}
      </div>
    </div>
  );
};
